import script from "./DueSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DueSelector.vue?vue&type=script&setup=true&lang=js"

import "./DueSelector.vue?vue&type=style&index=0&id=1f57bb0c&due=postcss&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f57bb0c"]])

export default __exports__